import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { APP_DATE_FORMATS, AppDateAdapter } from './datepicker-format';

@Component({
  selector: 'app-datepicker',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    FormsModule,
  ],
  template: `
    <mat-form-field appearance="outline">
      <mat-label>{{ label() }}</mat-label>
      <input
        matInput
        [matDatepicker]="dp"
        [(ngModel)]="date"
        [disabled]="disabled()"
      />
      <mat-hint>{{ dateFormatString() }}</mat-hint>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dp"
        [disabled]="disabled()"
      ></mat-datepicker-toggle>
      <mat-datepicker #dp [startView]="startView()"></mat-datepicker>
    </mat-form-field>
  `,
  styles: `
    mat-form-field {
      margin-right: 12px;
    }
  `,
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatepickerComponent {
  // Inputs
  label = input<string>($localize`:@@lib.shared-ui.datepicker:Datum auswählen`);
  startView = input<'month' | 'year' | 'multi-year'>('month');
  disabled = input<boolean>(false);

  // Model for two-way binding
  date = model<Date | null>(null);

  // Computed values
  readonly dateFormatString = computed(() => {
    return 'DD-MM-YYYY';
  });
}
